import api from '../..'

export const destroySurveyBlock = (blockSurveysId: number) => {
  return api.delete(`administration/block_surveys/${blockSurveysId}`)
}
export const destroyTextImageBlock = (blockRichTextId: number) => {
  return api.delete(`administration/block_rich_texts/${blockRichTextId}`)
}
export const destroyTaskBlock = (blockTasktId: number) => {
  return api.delete(`administration/block_tasks/${blockTasktId}`)
}
export const destroyMultimediaBlock = (blockMultimediaId: number) => {
  return api.delete(`administration/block_multimedias/${blockMultimediaId}`)
}
export const destroyScormBlock = (blockScormId: number) => {
  return api.delete(`administration/block_scorm/${blockScormId}`)
}
export const destroyMeetingBlock = (blockMeetingId: number) => {
  return api.delete(`administration/block_meeting/${blockMeetingId}`)
}
export const destroySessionBlock = (blockSessionId: number) => {
  return api.delete(`administration/block_session/${blockSessionId}`)
}
export const destroyOldEvaluation = (blockEvaluationId: number) => {
  return api.delete(`administration/block_evaluations/${blockEvaluationId}`)
}

export const destroyEvaluation = (blockEvaluationId: number) => {
  return api.delete(`administration/evaluations/${blockEvaluationId}`)
}
